import React, { useState, useEffect } from 'react';
import { createTurno } from '../../Api/TurnoApi';

function IngresoTurno() {
  const [cedula, setCedula] = useState('');
  const [errorMessage, setErrorMessage] = useState(null);
  const [successMessage, setSuccessMessage] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);   // ← NUEVO

  const handleNumberClick = (num) => {
    if (cedula.length < 11) setCedula(prev => prev + num);
  };

  const handleDelete = () => {
    setCedula(prev => prev.slice(0, -1));
  };

  const handleSubmit = async () => {
    if (isSubmitting) return;  // ← evita doble click

    setErrorMessage(null);
    setSuccessMessage(null);
    setIsSubmitting(true);  // ← DESACTIVA BOTÓN

    if (!cedula) {
      setErrorMessage("⚠️ Por favor, ingrese su cédula.");
      setIsSubmitting(false);
      return;
    }

    const cedulaNumber = parseInt(cedula, 10);
    if (isNaN(cedulaNumber) || cedulaNumber <= 0) {
      setErrorMessage("⚠️ Por favor, ingrese una cédula válida.");
      setIsSubmitting(false);
      return;
    }

    // Timeout de 60 segundos
    const timeoutPromise = new Promise((_, reject) =>
      setTimeout(() => reject(new Error("timeout")), 60000)
    );

    try {
      await Promise.race([createTurno(cedula), timeoutPromise]);
      setSuccessMessage(`✅ Turno creado para la cédula: ${cedula}`);
    }
    catch (error) {
      if (error.message === "timeout") {
        setErrorMessage("❌ El servidor tardó demasiado. Intente nuevamente.");
      }
      else if (error.response && error.response.status === 404) {
        setErrorMessage("❌ No se ha encontrado su cédula. Llame a recepción para su registro.");
      }
      else if (error.response && error.response.status === 400) {
        setErrorMessage("❌ Ya tiene un turno pendiente. Por favor, espere su turno.");
      }
      else {
        console.error("Error al crear el turno:", error);
        setErrorMessage("❌ Ocurrió un error al crear el turno. Por favor, inténtelo de nuevo.");
      }
    }
    finally {
      setCedula('');
      setIsSubmitting(false);  // ← REACTIVA BOTÓN
    }
  };

  useEffect(() => {
    if (errorMessage || successMessage) {
      const timer = setTimeout(() => {
        setErrorMessage(null);
        setSuccessMessage(null);
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [errorMessage, successMessage]);

  const keypadNumbers = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0'];

  const baseButtonStyle = {
    width: 'clamp(110px, 22vw, 160px)',
    height: 'clamp(110px, 22vw, 160px)',
    margin: '10px',
    fontSize: 'clamp(2.4rem, 4.5vw, 3.4rem)',
    fontWeight: '700',
    color: '#fff',
    border: 'none',
    borderRadius: '30px',
    transition: 'all 0.15s ease',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    boxShadow: '0 6px 14px rgba(0,0,0,0.15)',
  };

  return (


    <div
      className="d-flex flex-column align-items-center justify-content-center"
      style={{
        minHeight: '100dvh',
        backgroundColor: '#f6f5f3',
        fontFamily: 'Inter, sans-serif',
        color: '#333',
        padding: '3rem',
        textAlign: 'center'
      }}
    >
      <h2 style={{
        fontSize: 'clamp(2.5rem, 4vw, 4rem)',
        marginBottom: '2rem',
        color: '#1f3b73',
        fontWeight: '800'
      }}>
        Ingrese su Cédula
      </h2>

      {errorMessage && (
        <div className="alert alert-danger text-center mt-3"
          style={{
            width: 'clamp(300px, 60vw, 500px)',
            fontSize: '1.6rem',
            padding: '1.2rem',
            borderRadius: '1rem'
          }}>
          {errorMessage}
        </div>
      )}
      {successMessage && (
        <div className="alert alert-success text-center mt-3"
          style={{
            width: 'clamp(300px, 60vw, 500px)',
            fontSize: '1.6rem',
            padding: '1.2rem',
            borderRadius: '1rem'
          }}>
          {successMessage}
        </div>
      )}

      {/* Display */}
      <div
        className="p-3 mt-5 mb-5 rounded shadow-sm"
        style={{
          width: 'clamp(330px, 55vw, 500px)',
          fontSize: 'clamp(2.8rem, 5vw, 3.8rem)',
          backgroundColor: '#ffffff',
          border: '3px solid #cfd8e3',
          borderRadius: '1.4rem',
          color: '#1f3b73',
          minHeight: '110px',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        }}
      >
        {cedula || '—'}
      </div>

      {/* Teclado */}
      <div
        className="d-grid gap-4 p-3 rounded shadow-lg"
        style={{
          width: 'clamp(380px, 80vw, 650px)',
          backgroundColor: '#eaf0fa',
          borderRadius: '2.8rem',
          paddingBottom: '3rem',
          paddingTop: '3rem',
          paddingLeft: '2rem',
          paddingRight: '2rem',
          boxShadow: '0 8px 20px rgba(0,0,0,0.12)'
        }}
      >

        <div className="d-flex flex-wrap justify-content-center">
          {keypadNumbers.slice(0, 9).map(num => (
            <button
              key={num}
              onClick={() => handleNumberClick(num)}
              style={{
                ...baseButtonStyle,
                backgroundColor: '#3b82f6'
              }}
            >
              {num}
            </button>
          ))}
        </div>

        {/* Última fila */}
        <div className="d-flex justify-content-center">
          <button
            onClick={handleDelete}
            style={{
              ...baseButtonStyle,
              backgroundColor: '#ef4444',
            }}
          >
            ⌫
          </button>

          <button
            onClick={() => handleNumberClick('0')}
            style={{
              ...baseButtonStyle,
              backgroundColor: '#3b82f6',
            }}
          >
            0
          </button>

          {/* ✔ botón con isSubmitting */}
          <button
            onClick={handleSubmit}
            disabled={isSubmitting}
            style={{
              ...baseButtonStyle,
              backgroundColor: isSubmitting ? '#6ee7b7' : '#10b981',
              opacity: isSubmitting ? 0.7 : 1,
              cursor: isSubmitting ? 'not-allowed' : 'pointer',
              position: 'relative'
            }}
          >
            {isSubmitting ? (
              <div
                style={{
                  width: '40px',
                  height: '40px',
                  border: '5px solid rgba(255,255,255,0.4)',
                  borderTopColor: '#fff',
                  borderRadius: '50%',
                  animation: 'spin 0.8s linear infinite'
                }}
              />
            ) : (
              '✔'
            )}
          </button>

        </div>
      </div>
    </div>
  );
}

export default IngresoTurno;
